module.exports = __webpack_public_path__ + "static/media/linkedIn.d6254a0a.svg";